import {
  addDoc,
  collection,
  doc,
  limit,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import { db } from '../../lib/firebase';
import type { User } from '../../lib/types';

export const generalChatRef = (tenantUid: string) => doc(db, 'generalChats', tenantUid);
export const generalMessagesQuery = (tenantUid: string) =>
  query(
    collection(db, 'generalChats', tenantUid, 'messages'),
    orderBy('createdAt', 'asc'),
    limit(500),
  );
export const inboxQuery = () =>
  query(collection(db, 'generalChats'), orderBy('lastMessageAt', 'desc'), limit(500));

export async function sendGeneralMessage(
  tenantUid: string,
  profile: User,
  text: string,
  imagePaths: string[] = [],
): Promise<void> {
  await addDoc(collection(db, 'generalChats', tenantUid, 'messages'), {
    senderId: profile.id,
    senderRole: profile.role,
    text: text.trim(),
    type: 'text',
    ...(imagePaths.length ? { imagePaths } : {}),
    createdAt: serverTimestamp(),
  });
}

export async function markGeneralRead(tenantUid: string, role: User['role']): Promise<void> {
  await updateDoc(
    generalChatRef(tenantUid),
    role === 'admin'
      ? { adminLastReadAt: serverTimestamp(), unreadForAdmin: 0 }
      : { tenantLastReadAt: serverTimestamp(), unreadForTenant: 0 },
  );
}
